import clsx from 'clsx';
import {ReactNode} from 'react';

type MainHeadingProps = {
  className?: string;
  children: ReactNode;
};

const MainHeading: React.FC<MainHeadingProps> = ({className, children}) => {
  return <h1 className={clsx(className, 'text-2xl font-bold')}>{children}</h1>;
};
export default MainHeading;
